<template>
  <el-container>
    <el-header>
      <label class="title-font-size">登録用QRコード発行</label>
      <label class="subtitle-font-size"
        >登録用QRコード発行が完了いたしました。</label
      >
    </el-header>
    <el-main>
      <div class="codeGeneration">
        <div>
          <vue-qrcode :value="qrcode" :options="{ width: 160 }"></vue-qrcode>
        </div>
        <label class="expiry">
          <div>受付番号：{{ receiptNumber }}</div>
          <div>有効期限：{{ is_indefinite_period ? "" : expirationDate }}</div>
          <div>発行日時：{{ issueDate }}</div>
        </label>
      </div>
      <br />
      <div>
        <label class="attention">
          注意事項<br />
          ・身分証明書と本QRコードを店舗従業員にご提示下さい。内容を確認の上、会員カードを発行いたします。<br />
          ・有効期限がございますので有効期限内にご来店下さい。<br />
          ・この画面は当店LINEページから再表示することが出来ます。
        </label>
      </div>
    </el-main>
    <el-footer>
      <el-button class="footer-button" @click="clickEditButton"
        >登録情報変更</el-button
      >
      <el-button class="footer-button" @click="clickDeleteButton"
        >登録情報削除</el-button
      >
    </el-footer>
  </el-container>
  <el-dialog
    width="95%"
    v-model="deleteDialogFlag"
    center
    top="30vh"
    :show-close="false"
  >
    <span>{{ deleteDialogMsg }}</span>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="deleteQrCodeInfo"
          >OK</el-button
        >
        <el-button @click="deleteDialogFlag = false">キャンセル</el-button>
      </span>
    </template>
  </el-dialog>
  <el-dialog
    width="95%"
    v-model="deleteCompleteDialogFlag"
    center
    top="30vh"
    :show-close="false"
  >
    <span>{{ deleteCompleteDialogMsg }}</span>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="closepopup"
          >OK</el-button
        >
      </span>
    </template>
  </el-dialog>
  <el-dialog
    width="95%"
    v-model="APIerrorDialogFlag"
    center
    top="30vh"
    :show-close="false"
  >
    <span>{{ APIerrorDialogMsg }}</span>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="APIerrorDialogFlag = false"
          >OK</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      getQrInfoUrl:
        this.$store.state.baseUrl + 'line/qr/' +
        this.$store.state.storeId + "/" +
        this.$store.state.lineId, // QR情報取得API URL
      deleteQrInfoUrl:
        this.$store.state.baseUrl + 'line/receipt/' +
        this.$store.state.storeId + "/", // QR情報削除API URL
      receiptNumber: "", // 受付番号(画面表示用)
      expirationDate: "", // 有効期限(画面表示用)
      is_indefinite_period: true,
      issueDate: "", // 発行日時(画面表示用)
      qrCodeIssueDate: "", // 発行日時(QRコード用)
      qrcode: this.$store.state.storeId, // qr文字列(QRコード用)
      deleteDialogFlag: false,
      deleteDialogMsg: "登録内容を削除してもよろしいですか？",
      deleteCompleteDialogFlag: false,
      deleteCompleteDialogMsg: "登録内容を削除しました。",
      APIerrorDialogFlag: false,
      APIerrorDialogMsg:
        "サーバとの通信に失敗しました。時間をおいて再度アクセスしてください。",
    };
  },
  created() {
    this.axios
      .get(this.getQrInfoUrl)
      .then((response) => {
        // 受付番号
        this.is_indefinite_period = response.data.is_indefinite_period;
        this.receiptNumber = response.data.receipt_number;
        // 有効期限(画面表示用)
        var tmpExpirationDate = response.data.expiration_date;
        this.expirationDate =
          tmpExpirationDate.substr(0, 4) +
          "年" +
          tmpExpirationDate.substr(5, 2) +
          "月" +
          tmpExpirationDate.substr(8, 2) +
          "日";
        // 発行日時(画面表示用)
        var tmpIssueDate = response.data.signup_date_time;
        this.issueDate =
          tmpIssueDate.substr(0, 4) +
          "年" +
          tmpIssueDate.substr(5, 2) +
          "月" +
          tmpIssueDate.substr(8, 2) +
          "日 " +
          tmpIssueDate.substr(11, 5);
        // 発行日時(QRコード用) //YYYYMMDDHHMMSS
        var tmpQrCodeIssueDate = response.data.signup_date_time;
        this.qrCodeIssueDate =
          tmpQrCodeIssueDate.substr(0, 4) +
          tmpQrCodeIssueDate.substr(5, 2) +
          tmpQrCodeIssueDate.substr(8, 2) +
          tmpQrCodeIssueDate.substr(11, 2) +
          tmpQrCodeIssueDate.substr(14, 2) +
          tmpQrCodeIssueDate.substr(17, 2);
        // QRコード生成
        this.qrcode =
          response.data.store_id +
          "," +
          this.receiptNumber +
          "," +
          this.qrCodeIssueDate;
      })
      .catch(() => {
        this.APIerrorDialogFlag = true;
      });
  },
  methods: {
    clickEditButton() {
      this.$router.push({ name: "MemberRegist", params: {} });
    },
    clickDeleteButton() {
      this.deleteDialogFlag = true;
    },
    deleteQrCodeInfo() {
      this.axios
        .delete(this.deleteQrInfoUrl + this.receiptNumber)
        .then(() => {
          this.deleteDialogFlag = false;
          this.deleteCompleteDialogFlag = true;
        })
        .catch(() => {
          this.dialogMsg =
            "サーバとの通信に失敗しました。時間をおいて再度アクセスしてください。";
          this.APIerrorDialogFlag = true;
          this.deleteDialogFlag = false;
        });
    },
    closepopup: function () {
      this.deleteCompleteDialogFlag = false;
      //会員登録メニューへ遷移
      this.$router.push({ name: "MemberRegistMenu", params: {} });
    },
  },
};
</script>
<style scoped>
.el-container {
  height: 100%;
}
.el-header {
  height: 100px;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: center;
}
.el-main {
  padding-top: 0%;
}
.el-footer {
  padding: 0;
  height: 80px;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: flex-end;
}
.footer-button {
  font-size: 1rem;
  font-weight: bold;
  color: #ffffff;
  background-color: #0d5cbb;
  border-color: #636363;
  height: 40%;
  width: 100%;
  border-radius: 0;
  margin: 0;
}
.codeGeneration {
  text-align: center;
}
.expiry {
  display: inline-block;
  text-align: left;
  position: relative;
  font-size: 0.95rem;
  font-weight: bold;
}
.attention {
  color: #f94c07;
  text-align: left;
  font-size: 0.9rem;
  font-weight: bold;
}
#dialogInButton {
  width: 30vw;
  border-radius: 0;
}
</style>